import React from 'react';
import tw from 'twin.macro';
import { css } from '@emotion/react';

import type { InteractionModalTitleProps } from '$/components/Interactions/types';

import { FeaturedOnProductHunt } from './FeaturedOnProductHunt';
import Modal from '$/components/ui/Modal';

export const ProductHuntPromoInteractionModalTitle: React.FC<InteractionModalTitleProps> = () => {
  return (
    <Modal.Title
      className='flex items-center relative w-full text-white'
      css={css`
        ${tw`rounded-lg`}
        padding: 2rem;
        background: #eb491a;
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
      `}
    >
      <FeaturedOnProductHunt size='modal' votes={null} />
    </Modal.Title>
  );
};
